/* create a swiper slider */
const initSwiper = (elementOrSelector) => {      
  // 1. Obtener el elemento contenedor
  const container =
    typeof elementOrSelector === "string"
      ? document.querySelector(elementOrSelector)
      : elementOrSelector;
  
  if (!container || !(container instanceof HTMLElement)) {
    //console.error("Error: Elemento contenedor de Swiper no encontrado o no es un elemento válido.");
    return;
  }

  const paginateElement = container.querySelector(".swiper-pagination");

  // Opciones por defecto
  const defaultOptions = {
    direction: "horizontal",
    loop: false,
    pagination: paginateElement
      ? {
        el: paginateElement,
        clickable: true,
      }
      : false,
  };

  // Leer y parsear configuración del HTML
  let configFromHTML = {};
  const configData = container.getAttribute("data-swiper-config");

  if (configData) {
    try {
      configFromHTML = JSON.parse(configData);
    } catch (error) {
      console.error(
        "Error al parsear la configuración Swiper del HTML:",
        error,
        "en el contenedor:",
        container
      );
    }
  }

  // Fusionar configuraciones
  // Swiper necesita el *elemento* como primer argumento, no en la configuración.
  const finalConfig = {
    ...defaultOptions,
    ...configFromHTML,
  };

  // Inicializar Swiper
  new Swiper(container, finalConfig);

}

const setupTimelineEffects = () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        //console.error("GSAP o ScrollTrigger no están cargados.");
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.getAll().forEach((st) => {
        if (
            st.vars.trigger === ".timeline__container" ||
            (st.vars.trigger instanceof Element &&
                st.vars.trigger.classList.contains("dot"))
        ) {
            st.kill();
        }
    });

    const lineFill = document.querySelector(".line-fill");
    const lineBg = document.querySelector(".line-bg");
    const timeline = document.querySelector(".timeline__container");

    if (!timeline || !lineFill || !lineBg) {
        //console.warn("Elementos no encontrados. Abortando.");
        return;
    }

    const dots = timeline.querySelectorAll(".dot");
    if (dots.length === 0) {
        //console.warn("No se encontraron puntos (dots).");
        return;
    }

    const lastDotElement = dots[dots.length - 1];
    const firstDotElement = dots[0];

    const timelineRect = timeline.getBoundingClientRect();
    const lastDotRect = lastDotElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const timelineTopAbsolute = timelineRect.top + scrollTop;
    const lastDotTopAbsolute =
        lastDotRect.top + scrollTop + lastDotRect.height / 2;

    const maxHeight = lastDotTopAbsolute - timelineTopAbsolute;

    // Línea gris estática con altura fija
    lineBg.style.position = "absolute";
    lineBg.style.left = "";
    lineBg.style.top = "";
    lineBg.style.width = "4px";
    lineBg.style.height = `${maxHeight}px`;
    lineBg.style.backgroundColor = "#d6ccc2";

    // Línea rellena animada
    lineFill.style.position = "absolute";
    lineFill.style.left = "";
    lineFill.style.top = "";
    lineFill.style.width = "4px";
    lineFill.style.height = "0px";
    lineFill.style.backgroundColor = "#a46c32";

    gsap.to(lineFill, {
        height: maxHeight,
        ease: "none",
        scrollTrigger: {
            trigger: timeline,
            start: "top center",
            end: "bottom center",
            scrub: true,
            markers: false,
        },
    });

    const targetImage = document.querySelector(".history-section__image");
    if (!targetImage) {
        //console.warn("Imagen de destino no encontrada.");
        return;
    }

    dots.forEach((dot, i) => {
        const dotContainer = dot.closest(".timeline__item");
        const sourceImageElement = dotContainer.querySelector(".timeline-image-source");
        const sourceImageUrl = sourceImageElement ? sourceImageElement.src : null;
        if (!sourceImageUrl) {
            //console.warn(`No se encontró URL para dot ${i + 1}`);
            return;
        }
        ScrollTrigger.create({
            trigger: dot,
            start: "top center",
            end: "bottom center",
            toggleClass: { targets: dot, className: "bg-primary" },
            onEnter: () => {
                gsap.to(dot, { backgroundColor: "#a46c32" });
                gsap.to(targetImage, {
                    opacity: 0,
                    duration: 0.3,
                    onComplete: () => {
                        targetImage.src = sourceImageUrl;
                        targetImage.alt = sourceImageElement.alt;
                        gsap.to(targetImage, { opacity: 1, duration: 0.5 });
                    },
                });
            },
            onLeaveBack: () => {
                if (i > 0) {
                    const prevDotContainer = dots[i - 1].closest(".timeline__item");
                    const prevSourceImageElement = prevDotContainer.querySelector(".timeline-image-source");
                    const prevSourceImageUrl = prevSourceImageElement ? prevSourceImageElement.src : null;
                    if (prevSourceImageUrl) {
                        gsap.to(targetImage, {
                            opacity: 0,
                            duration: 0.3,
                            onComplete: () => {
                                targetImage.src = prevSourceImageUrl;
                                targetImage.alt = prevSourceImageElement.alt;
                                gsap.to(targetImage, { opacity: 1, duration: 0.5 });
                            },
                        });
                    }
                }
                gsap.to(dot, { backgroundColor: "#d6ccc2" });
            },
        });
    });

    ScrollTrigger.refresh();
};

  const readTimeLine = () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        //console.error("GSAP o ScrollTrigger no están cargados.");
        return;
    }
      const mediaQuery = window.matchMedia('(min-width: 769px)');

      const handleMediaChange = (mq) => {
          if (mq.matches) {
              setupTimelineEffects();
          } else {

              ScrollTrigger.getAll().forEach(st => st.kill());
              const lineFill = document.querySelector(".line-fill");
              if (lineFill) {
                  gsap.set(lineFill, { height: '100%', backgroundColor: '#d6ccc2' });
              }
          }
      };
      handleMediaChange(mediaQuery);
      mediaQuery.addListener(handleMediaChange);
  };

/**
 * Configura el Intersection Observer para cambiar dinámicamente
 * la imagen principal (targetImage) basada en qué .timeline__item
 * está visible dentro del .timeline__container.
 */
const setupTimelineImageObserver = () => {
    if (typeof gsap === "undefined") {
        //console.error("GSAP no está cargado. Abortando Intersection Observer.");
        return;
    }

    const timelineContainer = document.querySelector('.timeline__container');
    const timelineItems = document.querySelectorAll('.timeline__item');
    const targetImage = document.querySelector(".history-section__image");

    if (!timelineContainer || timelineItems.length === 0 || !targetImage) {
        //console.warn("Faltan elementos HTML clave (.timeline__container, .timeline__item, o .history-section__image).");
        return;
    }

    const observerOptions = {
        root: timelineContainer,
        rootMargin: '0px',
        threshold: 0.2
    };

    const handleIntersection = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const currentItem = entry.target;
                const sourceImage = currentItem.querySelector('img');

                if (sourceImage) {
                    if (targetImage.src !== sourceImage.src) {
                        gsap.to(targetImage, {
                            opacity: 0,
                            duration: 0.3,
                            onComplete: () => {
                                targetImage.src = sourceImage.src;
                                targetImage.alt = sourceImage.alt;
                                gsap.to(targetImage, { opacity: 1, duration: 0.5 });
                            },
                        });
                    }
                }
            }
        });
    };
    const observer = new IntersectionObserver(handleIntersection, observerOptions);

    timelineItems.forEach(item => {
        observer.observe(item);
    });
}


document.addEventListener('DOMContentLoaded', setupTimelineImageObserver);

document.addEventListener("DOMContentLoaded", readTimeLine);

window.addEventListener("resize", readTimeLine);
window.addEventListener("load", readTimeLine);